import { render, staticRenderFns } from "./DevicesSoldDetailsChart.vue?vue&type=template&id=bdf208aa&scoped=true&"
import script from "./DevicesSoldDetailsChart.vue?vue&type=script&lang=js&"
export * from "./DevicesSoldDetailsChart.vue?vue&type=script&lang=js&"
import style0 from "./DevicesSoldDetailsChart.vue?vue&type=style&index=0&id=bdf208aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf208aa",
  null
  
)

export default component.exports